const Shared = require("Sources/shared");
const LanguageManager = require("Sources/services/language-manager");
const utils = require("Sources/utils/utils");
const log = require("Sources/utils/logger")();
const LoginManager = require("Sources/services/login-manager");
const StorageController = require("Sources/controllers/storage-controller");
const FormValidator = require("Sources/components/form-validator");
const Constants = require("Sources/config/constants")

import UserServices from "../services/user-services";

require("Styles/pages/register.scss");

$(function()
{
  Shared.init();
  RegisterPage.init();
});

let RegisterPage = {};

((RegisterPage) =>
{

  let registerFormValidator = null;

  RegisterPage.init = function()
  {
    setUpRegisterForm();
    setUpEventListeners();

    clearAllFieldErrors();

    showRegisterPart();
  };

  function setUpEventListeners()
  {
    let $confirmRegisterBtn = $(".confirm-registration-btn");
    $confirmRegisterBtn.prop("disabled", true);

    let $cancelRegisterBtn = $("#cancel-registration-btn");
    $cancelRegisterBtn.on("click", function () { utils.redirect("/login"); });

    let $eulaCheckbox = $("#register-eula-checkbox");
    $eulaCheckbox.prop("checked", false);

    $eulaCheckbox.on("change", function(e)
    {
      $confirmRegisterBtn.prop("disabled", !this.checked);
    });

    $confirmRegisterBtn.on("click", function (e)
    {
      register();
    });

    $("#gameboardcode-info-btn").on("click", function()
    {
      $("#boardcode-info-modal").modal("show");
    });

    Shared.setupGameboardCodeInput("#register-gameboard_code-input");
  }

  function clearAllFieldErrors()
  {
    $(".form-control").removeClass("is-invalid");
    $(".input-field-error").text("");
  }

  function setUpRegisterForm()
  {
    registerFormValidator = new FormValidator({
      selector: "#register-form",
      validateOnChange: true,
      rules: {
        firstname: { required: true },
        lastname: { required: true },
        email:
          {
            required: true,
            overwriteValidator: function(value)
            {
              let isValid = utils.isValidEmail(value);
              if (!isValid)
              {
                $("#register-email-input-error").text(LanguageManager.getValueForKey(Constants.USER_EMAIL_INVALID));
              }
              else
              {
                $("#register-email-input-error").text("");
              }

              return isValid;
            }
          },
        gameboardCode:
          {
            required: true,
            minLength: 14,
            maxLength: 14
          },
        password: {
          required: true,
          // minLength: 6,
          maxLength: 32
        },
        passwordRepeat: {
          required: true,
          // minLength: 6,
          maxLength: 32,
          sameAs: "password",
          overwriteValidator: function(value)
          {
            let psw = $("#register-password-input").val();
            let isValid = psw === value;

            if (!isValid)
            {
              let message = LanguageManager.getValueForKey("register.form.passwords_dont_match");
              $("#register-password-input-error").text(message);
              $("#register-password-repeat-input-error").text(message);
            }
            else
            {
              $("#register-password-input-error").text("");
              $("#register-password-repeat-input-error").text("");
            }

            return isValid;
          }
        },
      }
    });
  }

  function register()
  {
    clearAllFieldErrors();

    //TODO: move to own function
    let isValid = registerFormValidator.validate();

    if(isValid)
    {
      let formData = registerFormValidator.getFormData();

      let user = {
        firstname: formData.firstname,
        lastname: formData.lastname,
        username: formData.email,
        gameboardCode: formData.gameboardCode,
        email: formData.email,
        password: formData.password
      };

      let $btn = $(".confirm-registration-btn");
      $btn.prop("disabled", true).removeClass("btn-loading").addClass("btn-loading");

      UserServices.registerUser(user)
        .then((data) =>
        {
          showValidationPart(formData.email);
        })
        .catch((appError) =>
        {
          let message = LanguageManager.getValueForKey(appError.code);
          switch (appError.code)
          {
            case Constants.USER_EMAIL_INVALID:
            case Constants.USER_DUPLICATE_EMAIL:
            case Constants.USER_NOT_FOUND:
            case Constants.USER_NOT_AUTHENTICATED:
              $("#register-email-input-error").text(message);
              $("#register-email-input").addClass("is-invalid");
              return;

            case Constants.PASSWORD_FORMAT_INVALID:
              $("#register-password-input-error").text(message);
              $("#register-password-input").addClass("is-invalid");
              return;

            case Constants.GAMEBOARD_NOT_FOUND:
            case Constants.GAMEBOARD_MAX_USERS_REACHED:
              $("#register-gameboard_code-input-error").text(message);
              $("#register-gameboard_code-input").addClass("is-invalid");
              return;
          }

          showGlobalError(appError.code);

        })
        .finally(() =>
        {
          $btn.prop("disabled", false).removeClass("btn-loading");
        });
    }
  }

  function showRegisterPart()
  {
    $("#part-register").show();
    $("#part-validate").hide();
  }

  function showValidationPart(email)
  {
    let message = LanguageManager.getValueForKey("register.validation.text");
    let formattedMessage = utils.format(message, [email]);
    $("#validation-text").html(formattedMessage);

    $("#part-register").hide();
    $("#part-validate").show();
  }

  function showGlobalError(errorCode)
  {
    console.log(errorCode);
    let errorPopup = $(".error-popup");
    errorPopup.removeClass("show");
    //trigger reflow
    errorPopup.width();
    errorPopup.addClass("show");
    $(".error-popup .error-message").attr("data-localize", errorCode);
    LanguageManager.applyLocale($(".error-popup .error-message"));
  }

})(RegisterPage);



// WEBPACK FOOTER //
// ./app/js/entries/register.js